<template>
	<div class="page1warp">
		<div class='serviceCatalog-warp'>
			
				<div v-html="contentObj.content" class='ruleDetail_box'></div>
		
		</div>
	</div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
	data() {
		return {
			currentPage: 1,
			PageSize: 1,
			contentObj: {}

		}
	},
	mounted() {
		this.getNewsData()
	},
	methods: {
		async getNewsData() {
			let params = {
				pageSize: 4,
				pageCurrent: 1,
				pressSuperClass: "21",
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				if (data.result.list.length != 0) {
					let id = data.result.list[0].pressId
					this.getnewdetail(id)
				}
			}
		},
		async getnewdetail(id) {
			let data = await httpService.getNewsDetails(id);
			if (data.result) {
				this.contentObj = data.result
			}
		},
	}
}
</script>
<style lang="less" scoped>
.page1warp {
	width: 1120px;
	margin-top: 20px;
	.serviceCatalog-warp {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 20px 40px;

		.ruleDetail_box {
			height: 560px;
			text-align: center;
		}
		overflow-y: scroll;
	}
}
</style>


